import { useCallback, useMemo } from 'react';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { PAYMENT_TYPE } from 'modules/billing-and-payments/config/PaymentType';
import { generatePaymentMethodFormPath } from 'modules/billing-and-payments/config/routes/generatePaymentMethodFormPath';

export const useBillingTools = () => {
    const navigate = useNavigate();

    const openCreateCreditCard = useCallback(() => {
        const createPath = generatePaymentMethodFormPath({
            mode: FORM_MODES.CREATE,
            paymentMethodType: PAYMENT_TYPE.CARD,
        });

        navigate(createPath);

        return true;
    }, [navigate]);

    return useMemo(() => ({ openCreateCreditCard }), [openCreateCreditCard]);
};
